import uniqWith from "lodash/uniqWith";
import { selectorFamily } from "recoil";

import { Type } from "../../models/configuration/definitions/widget";
import { WidgetStateReturn, widgetStatesAtom, WidgetUIState } from "./atoms";
import { WidgetTypeExtended } from "./models";

export const typesToIgnoreArray: WidgetTypeExtended[] = [
  Type.Attachments,
  Type.Sheet,
  "NOT_A_WIDGET_YET",
];

export const widgetStateSelector = selectorFamily<
  { state: WidgetUIState | undefined; elementCount?: number },
  { id: string; type: WidgetTypeExtended }
>({
  key: "WidgetStateSelector",
  get:
    ({ id, type }) =>
    ({ get }) => {
      const { state, elementCount } =
        get(widgetStatesAtom).find(
          (ws) =>
            (typesToIgnoreArray.includes(type) && ws.type === type) ||
            (ws.id === id && ws.type === type),
        ) || {};
      return { state, elementCount };
    },
  set:
    ({ id, type }) =>
    (
      { set },
      {
        state,
        elementCount: elementCount,
      }: { state: WidgetUIState | undefined; elementCount?: number },
    ) => {
      if (state) {
        set(widgetStatesAtom, (prevVals) => {
          const newVal: WidgetStateReturn = { id, type, state, elementCount };

          const ws = prevVals.find(
            (w) =>
              (typesToIgnoreArray.includes(newVal.type) && w.type === type) ||
              (w.id === id && w.type === type),
          );

          if (ws) {
            return uniqWith([newVal, ...prevVals], (a, b) => a.id === b.id && a.type === b.type);
          }
          return [...prevVals, newVal];
        });
      }
    },
});
